<template>
  <div>
    <!-- Saving spinner overlay -->
    <div v-if="saving" class="saving-overlay">
      <div class="saving-overlay-content">
        <div class="spinner-border text-primary" style="width: 4rem; height: 4rem;" role="status">
          <span class="visually-hidden">Saving...</span>
        </div>
        <p class="mt-3 text-muted">Saving your answers...</p>
      </div>
    </div>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary sticky-top mb-5 pb-0">
      <div class="container-xl">
        <h4 class="navbar-brand w-25 mb-0">
          <LogoPublic />
        </h4>
      </div>
    </nav>
    <div
      v-if="saveerror === 1"
      class="alert alert-danger"
      role="alert"
    >
      <b>Your answers could not be saved, please contact {{ consultant_name }} for assistance</b>
    </div>
    <div
      v-show="question_sequence>-1 && !showtext && !alldone && !incontrolled"
      class="text-container mx-auto mt-4"
    >
      <div class="progress gdq-progress-bar" style="height: 1rem;">
        <div
          class="progress-bar bg-info"
          role="progressbar"
          :style="{ width: progressPercent + '%' }"
          :aria-valuenow="question_sequence + 1"
          aria-valuemin="0"
          :aria-valuemax="questions.length"
        />
      </div>
      <div class="text-sm text-end mt-2">
        {{ question_sequence+1 }} {{ text_38 }} {{ questions.length }}
      </div>
    </div>
    <form
      class="text-container"
      @submit.prevent="survey_code_submitted ? surveymember_check() : survey_code_check()"
      @keydown.enter.prevent="survey_code_submitted ? surveymember_check() : survey_code_check()"
    >
      <!-- Intro text section-->
      <div
        v-if="question_sequence > -1 && !incontrolled && questions[question_sequence]"
        class="mx-auto my-4 gdqquestion"
      >
        <h2 v-show="!alldone">
          <span v-show="questions[question_sequence].question_section === 'S'">{{ text_21 }}</span>
          <span v-show="questions[question_sequence].question_section === 'Q'">{{ text_22 }}</span>
          <span v-show="questions[question_sequence].question_section === 'E'">{{ text_24 }}</span>
        </h2>
        <span v-show="!alldone && questions[question_sequence].question_section === 'E'">{{ text_39 }}</span>
      </div>
      <!-- Start page -->
      <div
        v-show="question_sequence === -1"
        class="mx-auto mt-4"
      >
        <template v-if="!survey_code_submitted">
          <span
            v-if="isapi === '0'"
            class="h2 page-title mb-3 d-block"
            v-html="text_8"
          />
          <p v-if="isapi === '0'">
            <span
              v-if="isapi === '0'"
              class=""
              v-html="text_9"
            />
          </p>
          <p
            v-if="isapi === '0'"
            class="mb-5"
          >
            {{ text_10 }}
          </p>
          <div class="code-input-wrapper mx-auto mb-3">
            <input
              v-for="(char, index) in characters"
              :key="index"
              v-model="characters[index]"
              @input="onInput($event, index)"
              @keydown="onKeyDown($event, index)"
              @paste="onPaste($event)"
              @keyup.enter.prevent="survey_code_check"
              maxlength="1"
              pattern="[a-zA-Z0-9]*"
              :ref="'input-' + index"
              class="code-input text-uppercase"
              autocomplete="false"
            />
            <input class="d-none" type="hidden" v-model="survey_code" />
          </div>
          <div v-if="!this.survey_code_valid" class="text-danger mb-3">
            {{ text_7 }}
          </div>
        </template>
        <template v-else>
          <div
            v-if="showconsent"
            class="mt-5 mb-4"
          >
            {{ text_12 }}
          </div>
          <!-- Consent text -->
          <div class="row" v-if="showconsent">
            <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mx-auto">
              <div v-if="this.groupsurveymember && Number(this.groupsurveymember.groupsurveymember_formoption_id) !== 3">
                <div class="form-check" :class="{'is-invalid': !consent_personal_valid}">
                <input
                  id="consent-personal"
                  v-model="consent_personal"
                  class="form-check-input"
                  type="checkbox"
                  value="1"
                >
                  <label class="form-check-label" for="consent-personal">
                    <span
                      class=""
                      v-html="text_13"
                    />
                  </label>
                  <div
                    id="consent_personal-feedback"
                    class="invalid-feedback d-block"
                    v-if="!consent_personal_valid"
                  >
                    {{ text_6 }}
                  </div>
                </div>
              </div>
              <div
                class="form-check mt-3"
                v-if="this.survey_code_submitted"
              >
                <input
                  id="consent-research"
                  v-model="consent_research"
                  class="form-check-input"
                  type="checkbox"
                  value="1"
                >
                <label class="form-check-label" for="consent-research">
                  <span
                    class=""
                    v-html="text_14"
                  />
                </label>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!--
        Question section
      -->
      <div
        v-if="showquestionsection  && !incontrolled"
        class="text-container gdqquestion"
      >
        <h3 class="my-4 py-4">
          <span
            v-show="questions[question_sequence].question_section === 'Q' && !questions[question_sequence].question_is_control"
          >{{ questions[question_sequence].question_number }}.
          </span>
          {{ questions[question_sequence].question_text }}
        </h3>
        <!-- Question type 1 - Vertical Radio Buttons -->
        <div
          v-show="Number(questions[question_sequence].question_type) === 1"
          class="ml-0 pl-0"
        >
          <div class="btn-group btn-group-vertical btn-group-toggle w-100 mb-5">
            <label
              v-for="option in questions[question_sequence].options"
              :id="'o'+option.option_id"
              :key="option.option_id"
              class="btn btn-questionnaire my-2 text-start ms-0"
              :class="((answers[question_sequence] != null)&&(answers[question_sequence]===option.value))||currentoption===option.option_id&&!questions[question_sequence].question_is_control?'btn-primary':'btn-outline-primary'"
              :disabled="settinganswer"
              @click.prevent="currentoption=option.option_id;setanswer(question_sequence,option.value,questions[question_sequence].question_id);"
            >
              <span
                v-if="(answers[question_sequence] != null)&&(answers[question_sequence]===option.value)"
                class="mr-2"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 512 512"
                  focusable="false"
                  class="white fa-icon"
                >
                  <path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z" />
                </svg>
              </span>
              <span
                v-if="(answers[question_sequence] != null)&&(answers[question_sequence]!==option.value)"
                class="w-10 mr-2"
              >
              &nbsp;&nbsp;&nbsp;
              </span>
              <input
                type="radio"
                autocomplete="off"
                class="text-left"
                :checked="(answers[question_sequence] != null)&&(answers[question_sequence]===option.value)"
              >{{ option.text }}
            </label>
          </div>
        </div>
        <!-- Question type 2 - Textbox -->
        <div
          v-show="Number(questions[question_sequence].question_type) === 2"
          class="row mb-5"
        >
          <div class="col-12">
            <input
              v-if="Number(questions[question_sequence].only_digits) === 0 || questions[question_sequence].only_digits === null || questions[question_sequence].only_digits === undefined"
              v-model="answers[question_sequence]"
              :maxlength="getTextMaxLength(questions[question_sequence])"
              class="form-control col-12"
              type="text"
              ref="textAnswer"
              @keyup.enter="answers[question_sequence] !== '' ? nextpage(300) : false"
            />
            <input
              v-if="Number(questions[question_sequence].only_digits) === 1"
              v-model="answers[question_sequence]"
              :maxlength="getTextMaxLength(questions[question_sequence], 20)"
              class="form-control col-12"
              type="tel"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              ref="textAnswer"
              @keyup.enter="answers[question_sequence] !== '' ? nextpage(300) : false"
            />
            <div
              v-if="Number(questions[question_sequence].only_digits) === 1"
              class="col-12 mt-3 text-sm text-start"
            >
              {{ text_40 }}
            </div>

          </div>
          <div
            v-if="questionHint"
            class="col-12 mt-2 d-flex justify-content-end text-muted"
          >
            <span class="text-right">
              {{ questionHint }}
            </span>
          </div>
          <div
            v-if="Number(questions[question_sequence].only_digits) === 0 || questions[question_sequence].only_digits === null || questions[question_sequence].only_digits === undefined"
            class="col-12 mt-3 d-flex justify-content-end"
          >
            <span class="text-right">
              {{ text_27 }}: {{ getTextMaxLength(questions[question_sequence]) - ((answers[question_sequence]) ? answers[question_sequence].length : 0) }}
            </span>
          </div>
        </div>
        <!-- Question type 3 - Textarea -->
        <div v-show="Number(questions[question_sequence].question_type) === 3" class="mb-5">
          <textarea
            v-model="answers[question_sequence]"
            rows="7"
            :maxlength="getTextMaxLength(questions[question_sequence])"
            class="form-control col-12"
            @keydown.enter.stop
          ></textarea>
          <div class="row">
            <div class="col-12 text-end mt-3">
              {{ text_27 }}: {{ getTextMaxLength(questions[question_sequence]) - ((answers[question_sequence])?answers[question_sequence].length:0) }}
            </div>
          </div>
        </div>
        <!-- Question type 4 - Horizontal radio buttons -->
        <div
          v-show="Number(questions[question_sequence].question_type) === 4"
          class="row"
        >
          <div class="btn-group btn-group-horizontal btn-group-toggle col text-center">
            <label
              v-for="option in questions[question_sequence].options"
              :id="'o'+option.option_id"
              :key="option.option_id"
              class="btn btn-questionnaire btn-questionnaire-horizontal btn-iphone text-center py-4"
              :class="(answers[question_sequence] != null)&&(answers[question_sequence]===option.value)||currentoption===option.option_id?'btn-primary':'btn-outline-primary'"
              :disabled="settinganswer"
              @click.prevent="currentoption=option.option_id;setanswer(question_sequence,option.value,questions[question_sequence].question_id);"
            >
              <span
                v-if="answers[question_sequence] && answers[question_sequence] === option.value"
                class="mr-2"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 512 512"
                  focusable="false"
                  class="white fa-icon"
                >
                  <path d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z" />
                </svg>
              </span>
              <input
                type="radio"
                class="text-center"
              >{{ option.text }}
            </label>
          </div>
        </div>
        <div
          v-if="questions[question_sequence].question_section === 'Q' && Number(questions[question_sequence].question_type) === 4"
          class="row mb-5"
        >
          <div
            class="col-6 text-primary mt-3"
          >
            {{ text_25 }}
          </div>
          <div
            class="col-6 text-end text-primary mt-3"
          >
            {{ text_26 }}
          </div>
        </div>
      </div>
      <div
        v-if="question_sequence > -1 && question_sequence < questions.length && showtext && !incontrolled"
        class="mx-auto gdqquestion mb-5"
      >
        <div v-show="questions[question_sequence].question_section === 'Q'">
          <span
            class=""
            v-html="text_23"
          />
        </div>
      </div>
      <!-- FInal page -->
      <div
        v-show="alldone && saveerror === 0"
        class="mx-auto"
      >
        <h2>
          {{ text_28 }}
        </h2>
        <div>
          {{ text_20 }}
        </div>
      </div>
      <!-- Navigation buttons -->
      <div
        v-show="!alldone &&!incontrolled"
        class="row mb-5 align-items-center"
      >
        <div :class="question_sequence > 0 ? 'col-6 d-flex' : 'd-none'">
          <button
            v-show="question_sequence > 0"
            class="align-right btn btn-secondary"
            @click.prevent="prevpage"
          >
            &lt; {{ text_1 }}
          </button>
        </div>
        <div :class="question_sequence > 0 ? 'col-6 text-right d-flex justify-content-end' : 'col-12 text-right d-flex justify-content-end'">
          <button
            v-show="((question_sequence !== -1) || answers[question_sequence] )"
            class="align-right btn btn-primary"
            :disabled="((!(answers[question_sequence])||answers[question_sequence]==='') || settinganswer) && !showtext && (Number(questions[question_sequence]?.question_type) !== 3)"
            @click.prevent="nextpage(300)"
          >
            {{ text_2 }}
          </button>
        </div>
        <div class="border-0 d-flex justify-content-end">
          <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4 pl-0 px-0 ms-auto">
          <button
            v-show="question_sequence === -1 && this.survey_code_submitted && Number(this.groupsurveymember.groupsurveymember_formoption_id) !== 3"
            class="btn btn-primary w-100 mt-4"
            :disabled="(!consent_personal) || (isapi === '0' && survey_code === '')"
            @click.prevent="surveymember_check"
          >
            {{ text_4 }}
          </button>
          </div>
        </div>
        <div class="border-0 d-flex justify-content-end">
          <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-4 pl-0 px-0 ms-auto">
          <button
            v-show="question_sequence === -1 && !this.survey_code_submitted"
            class="btn btn-primary w-100"
            :disabled="(isapi === '0' && survey_code === '')"
            @click.prevent="survey_code_check"
          >
            {{ text_2 }}
          </button>
          </div>
        </div>
      </div>
    </form>
    <div
      v-if="Number(survey.survey_type_id) !== 3 && question_sequence === -1 && !survey_code_submitted"
      class="text-container mx-auto mt-4 text-sm"
    >
      {{ text_15 }}
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import LogoPublic from './LogoPublic.vue'

const sleep = (milliseconds) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export default {
  name: 'GDQQuestionnaire',
  components: {
    LogoPublic
  },
  props: {
    api: {
      type: String,
      required: false,
      default: '0'
    },
    successurl: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    const browserDetect = this.$browserDetect || {}
    const userAgent = (browserDetect.meta && browserDetect.meta.ua)
      ? browserDetect.meta.ua
      : (typeof navigator !== 'undefined' ? navigator.userAgent : '')
    const iPhone = typeof browserDetect.isIOS === 'boolean'
      ? browserDetect.isIOS
      : /iP(ad|hone|od)/i.test(userAgent)
    return {
      firstgdqsequence: 9999,
      answering: false,
      saving: false,
      isapi: this.api,
      saveerror: null,
      settinganswer: false,
      settingcontrolanswer: false,
      incontrolled: false,
      iPhone,
      userAgent,
      survey_id: (this.$store.state.questionnaire_admin === true) ? this.$store.state.currentsurvey_id : null,
      survey_code: this.$store.state.questionnaire_admin_code,
      characters: (this.$store.state.questionnaire_admin_code && this.$store.state.questionnaire_admin_code.length)
        ? this.$store.state.questionnaire_admin_code.split('').concat(Array(Math.max(0, 6 - this.$store.state.questionnaire_admin_code.length)).fill(''))
        : Array(6).fill(''),
      token: this.$route.params.t ? this.$route.params.t : '',
      currentoption: 0,
      survey_code_valid: true,
      survey_code_submitted: false,
      f: false,
      alldone: false,
      consultant_id: 0,
      consultant_name: '',
      consultant_email: '',
      survey: {
        survey_type_id: 1,
        survey_language_id: 0,
        survey_end_date: null
      },
      groupsurveymember_id: 0,
      groupsurveymember: {
        groupsurveymember_survey_code: '',
        groupsurveymember_token: '',
        groupsurveymember_formoption_id: 1
      },
      question_sequence: -1,
      questions: [],
      answers: [],
      controlanswers: [],
      showtext: true,
      showconsent: true,
      consent_personal: false,
      consent_personal_valid: true,
      consent_research: false,
      consent_research_valid: true,
      text_1: '',
      text_2: '',
      text_3: '',
      text_4: '',
      text_5: '',
      text_6: '',
      text_7: '',
      text_8: '',
      text_9: '',
      text_10: '',
      text_11: '',
      text_12: '',
      text_13: '',
      text_14: '',
      text_15: '',
      text_16: '',
      text_17: '',
      text_18: '',
      text_19: '',
      text_20: '',
      text_21: '',
      text_22: '',
      text_23: '',
      text_24: '',
      text_25: '',
      text_26: '',
      text_27: '',
      text_28: '',
      text_29: '',
      text_30: '',
      text_31: '',
      text_32: '',
      text_33: '',
      text_34: '',
      text_35: '',
      text_36: '',
      text_37: '',
      text_38: '',
      text_39: ''
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    questionHint () {
      const q = this.questions?.[this.question_sequence]
      return q?.question_hint || q?.hint || q?.question_helptext || ''
    },
    progressPercent () {
      if (!this.questions.length) {
        return 0
      }
      return ((this.question_sequence + 1) / this.questions.length) * 100
    },
    showquestionsection: function () {
      if (
        this.question_sequence > -1 &&
        this.question_sequence < this.questions.length &&
        !this.showtext &&
        !this.alldone
      ) {
        return true
      }
      return false
    }
  },
  created () {
    this.surveymember_get()
      .then((resp) => {
        const total = parseInt(resp.data.total, 10)
        if (total === 1 && resp.data.result[0].redirect_url) {
          window.location.replace(resp.data.result[0].redirect_url)
          return
        }
        if (!Number.isNaN(total) && total === 1) {
          this.survey_get()
            .then(() => {
              this.consultant_get()
                .then(() => {
                  this.answers = new Array()
                  this.questionnairetexts_get()
                  this.controlanswers = new Array()
                  this.gdqquestions_get()
                })
            })
        } else {
          alert('Incorrect link')
        }
      })
  },
  methods: {
    getTextMaxLength (q, fallback = 300) {
      const val = Number(q && q.text_maxlength)
      if (val && !Number.isNaN(val) && val > 0) {
        return val
      }
      return fallback
    },
    persistConsent (field, value) {
      if (!this.groupsurveymember_id) {
        return
      }
      const normalizedValue = (value === true || value === '1' || value === 1) ? 1 : 0
      this.savefield(this.groupsurveymember_id, field, normalizedValue)
    },
    log_start () {
      const data = {
        op: 'Questionnaire load',
        url: window.location.href,
        ll: 1
      }
      this.$store.dispatch('accesslog', data)
    },
    onInput (event, index) {
      this.survey_code_valid = true
      const value = event.target.value
      if (/^[a-zA-Z0-9]$/.test(value)) {
        this.characters[index] = value
        if (index < this.characters.length - 1) {
          const nextInput = this.$refs[`input-${index + 1}`]
          if (Array.isArray(nextInput)) {
            nextInput[0]?.focus()
          } else {
            nextInput?.focus()
          }
        }
        this.$emit('input', this.characters.join(''))
        this.survey_code = this.characters.join('')
      } else {
        this.characters[index] = ''
      }
    },
    onKeyDown (event, index) {
      this.survey_code_valid = true
      if (event.key === 'Backspace' && !this.characters[index] && index > 0) {
        const prevInput = this.$refs[`input-${index - 1}`]
        if (Array.isArray(prevInput)) {
          prevInput[0]?.focus()
        } else {
          prevInput?.focus()
        }
      }
    },
    onPaste (event) {
      this.survey_code_valid = true
      const paste = (event.clipboardData || window.clipboardData).getData('text')
      if (/^[a-zA-Z0-9]+$/.test(paste)) {
        const pasteCharacters = paste.slice(0, 6).split('')
        this.characters = pasteCharacters.concat(
          Array(6 - pasteCharacters.length).fill('')
        )
        this.$nextTick(() => {
          const targetInput = this.$refs[`input-${pasteCharacters.length - 1}`]
          if (Array.isArray(targetInput)) {
            targetInput[0]?.focus()
          } else {
            targetInput?.focus()
          }
        })
        this.$emit('input', this.characters.join(''))
        this.survey_code = this.characters.join('')
      }
    },
    async surveymember_check () {
      this.survey_code = this.survey_code.replace(' ', '').toUpperCase() // Convert to uppercase
      this.survey_code = this.survey_code.trim()
      if (this.groupsurveymember.groupsurveymember_survey_code.toString() !== this.survey_code.toString() && this.isapi === '0') {
        this.survey_code_valid = false
        return false
      }
      if (!this.questions.length) {
        await this.gdqquestions_get()
      }
      console.log('[GDQ] surveymember_check: questions', this.questions.length, 'question_sequence', this.question_sequence)
      this.nextpage(300)
    },
    async survey_code_check () {
      this.survey_code = this.survey_code.replace(' ', '').toUpperCase() // Convert to uppercase
      this.survey_code = this.survey_code.trim()
      if (this.groupsurveymember.groupsurveymember_survey_code.toString() !== this.survey_code.toString() && this.isapi === '0') {
        this.survey_code_valid = false
        return false
      }
      this.survey_code_submitted = true
      console.log('[GDQ] survey_code_check: code submitted, formoption', this.groupsurveymember.groupsurveymember_formoption_id, 'showconsent', this.showconsent, 'qs', this.question_sequence, 'questions', this.questions.length)
      if (!this.questions.length) {
        await this.gdqquestions_get()
      }
      if (Number(this.groupsurveymember.groupsurveymember_formoption_id) === 3) {
        this.showtext = false
        this.showconsent = false
        this.consent_personal = 1
        this.question_sequence = 0
      }
    },
    surveymember_get () {
      return new Promise((resolve) => {
        const filter = {
          groupsurveymember_token: {
            operator: '=',
            value: this.token
          },
          included_in_survey: {
            operator: '=',
            value: 1
          }
        }
        this.$store.dispatch('questionnaire_gdqsurveymember_fetch', { filter })
          .then((resp) => {
            const total = parseInt(resp.data.total, 10)
            if (total === 1) {
              console.log('[GDQ] surveymember_get result', resp.data.result[0])
              this.groupsurveymember_id = resp.data.result[0].id,
              this.groupsurveymember.groupsurveymember_survey_code = resp.data.result[0].groupsurveymember_survey_code
              this.groupsurveymember.groupsurveymember_token = resp.data.result[0].groupsurveymember_token
              this.groupsurveymember.groupsurveymember_formoption_id = resp.data.result[0].groupsurveymember_formoption_id
              if (Number(this.groupsurveymember.groupsurveymember_formoption_id) === 3) {
                this.showconsent = false
                this.consent_personal = 1
              }
              this.survey_id = resp.data.result[0].survey_id
              if (Number(resp.data.result[0].groupsurveymember_status_id) < 4) {
                this.savefield(this.groupsurveymember_id, 'groupsurveymember_status_id', 3)
              }
            }
            resolve(resp)
          })
      })
    },
    survey_get () {
      return new Promise((resolve) => {
        this.$store.dispatch('questionnaire_gdqsurvey_fetch', { survey_id: this.survey_id })
          .then((resp) => {
            this.survey = resp.data
            // Normalize addon_survey to a number so comparisons don’t fail when API returns string
            this.survey.addon_survey = Number(resp.data.addon_survey) || 0
            // this.survey.survey_language_id = resp.data.survey_language_id;
            // this.survey.survey_end_date = resp.data.survey_end_date;
            // this.survey.survey_type_id = resp.data.survey_type_id;
            this.consultant_id = resp.data.user_id
            resolve(resp)
          })
      })
    },
    questionnairetexts_get () {
      this.$store.dispatch('questionnairetexts_fetch', { language_id: this.survey.survey_language_id })
        .then((resp) => {
          const maillink = '<a href="mailto:' + this.consultant_email + '">' + this.consultant_name + '</a>'
          this.text_1 = resp.data[1] ? resp.data[1] : 'Back'
          this.text_2 = resp.data[2] ? resp.data[2] : 'Next'
          this.text_3 = resp.data[3] ? resp.data[3] : 'Submit'
          this.text_4 = resp.data[4] ? resp.data[4] : 'Go to the GDQ survey'
          this.text_5 = resp.data[5] ? resp.data[5] : 'Some questions require a response - please answer any questions highlighted in red'
          this.text_6 = resp.data[6] ? resp.data[6] : ''
          this.text_7 = resp.data[7] ? resp.data[7] : 'Invalid code'
          this.text_8 = resp.data[8] ? resp.data[8] : 'Welcome'
          // Consultant name with mailto link
          this.text_9 = resp.data[9] ? resp.data[9].replace('[consultant_name]', maillink) : 'You have received an invitation to complete this questionnaire because XX XX considers it to be a valuable tool for finding out more about your work group in order to help you and your colleagues gain a deeper understanding of how you work together as a group, and what can be done to help your work group work better.'
          this.text_10 = resp.data[10] ? resp.data[10] : 'Please enter your personal code to launch the questionnaire.'
          this.text_11 = resp.data[11] ? resp.data[11] : 'Enter your code here.'
          this.text_12 = resp.data[12] ? resp.data[12] : '...And please confirm that we have your consent to store your responses and personal details:'
          // Privacy policy
          const link = (Number(this.survey.survey_language_id) === 154 ? '<a href="https://gdq.se/sv/integritetspolicy2/" target="_new">' : '<a href="https://gdq.se/en/privacypolicy/" target="_new">')
          this.text_13 = resp.data[13] ? resp.data[13] : 'Yes, I give my consent to GDQ Associates to process my personal data for the reasons set out above in accordance with the company\'s privacy policy. If you would like further information about how we process your personal data and your rights in this regard, click here.'
          this.text_13 = this.text_13.replace('[link]', link)
          this.text_13 = this.text_13.replace('[/link]', '</a>')
          // Consent research
          this.text_14 = resp.data[14] ? resp.data[14] : 'I give my consent to my responses to this questionnaire being used anonymously without any identifying markers for the purposes of test development, standardisation and research.'
          let textno = 15
          if (Number(this.survey.survey_type_id) === 2) {
            textno = 36
          }
          this.text_15 = resp.data[textno] ? resp.data[textno] : 'All rights related to this questionnaire and the associated testing procedure and consultancy processes are the property of GDQ Associates AB. The Group Development Questionnaire (GDQ) is protected by copyright laws. Duplicating, printing or otherwise copying the contents of this questionnaire, in whole or in part, is thus prohibited without the permission of the copyright holder. It is prohibited for anyone other than a certified GDQ consultant to use this questionnaire.'
          this.text_16 = resp.data[16] ? resp.data[16] : 'Questionnaire already submitted'
          // Already completed
          this.text_17 = resp.data[17] ? resp.data[17].replace('[consultant_name]', maillink) : ''
          this.text_18 = resp.data[18] ? resp.data[18] : 'Please answer all questions marked with red color'
          this.text_19 = resp.data[19] ? resp.data[19].replace('[survey_end_date]', this.survey.survey_end_date) : ''
          this.text_20 = resp.data[20] ? resp.data[20] : 'Thank you!'
          this.text_21 = resp.data[21] ? resp.data[21] : 'Group Information and Personal Information'
          this.text_22 = resp.data[22] ? resp.data[22] : 'GDQ Questions'
          this.text_23 = resp.data[23] ? resp.data[23] : 'Please read each statement below. Choose the number that most accurately describes this group at the present time. Use the following key to respond to each statement.<br><br>1 = never true of this group<br>2 = rarely true of this group<br>3 = sometimes true of this group<br>4 = frequently true of this group<br>5 = always true of this group<br><br>Sample question: This group spends considerable time working on important issues.<br><br>If this is never true of this group, mark the number “1” in the box provided for this sample item. If working on important issues is a rare occurrence, mark the number “2” in the box. If working on important issues occurs to some extent, mark the number “3” in the box. If work of this type is frequent, mark the number “4” in the box. If the group, in your opinion, is always working on important issues, mark the number “5” in the box.<br><br>Using the same procedure respond to each of the following statements.'
          this.text_24 = resp.data[24] ? resp.data[24] : 'Free text response'
          this.text_25 = resp.data[25] ? resp.data[25] : 'Never true'
          this.text_26 = resp.data[26] ? resp.data[26] : 'Always true'
          this.text_27 = resp.data[27] ? resp.data[27] : 'Number of characters remaining '
          this.text_28 = resp.data[28] ? resp.data[28] : 'Thank you!'
          this.text_29 = resp.data[29] ? resp.data[29].replace('[consultant_name]', maillink) : 'Du har fått en inbjudan till denna enkät  [consultant_name] ser den som ett värdefullt verktyg för att ta reda på din och din grupps upplevelse av organisatoriska frågor. Syftet är att hjälpa dig och dina kollegor få insikt i hur ni upplever det organisatoriska stödet och uppmärksamma inom vilka områden fokus för utveckling bör riktas.'
          this.text_30 = resp.data[30] ? resp.data[30] : 'Please read each statement below. Choose the number that most accurately describes this group at the present time. Use the following key to respond to each statement.<br><br>1 = never true of this group<br>2 = rarely true of this group<br>3 = sometimes true of this group<br>4 = frequently true of this group<br>5 = always true of this group<br><br>Sample question: This group spends considerable time working on important issues.<br><br>If this is never true of this group, mark the number “1” in the box provided for this sample item. If working on important issues is a rare occurrence, mark the number “2” in the box. If working on important issues occurs to some extent, mark the number “3” in the box. If work of this type is frequent, mark the number “4” in the box. If the group, in your opinion, is always working on important issues, mark the number “5” in the box.<br><br>Using the same procedure respond to each of the following statements.'
          this.text_31 = resp.data[31] ? resp.data[31] : 'OSC Questions'
        if (Number(this.survey.survey_type_id) === 3) {
          this.text_23 = this.text_30
          this.text_9 = this.text_29
          this.text_22 = this.text_31
        }
          this.text_37 = resp.data[37] ? resp.data[37] : '* = mandatory question'
          this.text_38 = resp.data[38] ? resp.data[38] : 'of'
          this.text_39 = resp.data[39] ? resp.data[39] : 'Your free text responses will be included in the GDQ report alongside other people\'s free text responses.'
          this.text_40 = resp.data[40] ? resp.data[40] : 'Enter with numbers'
        })
    },
    async setanswer (id, answer, question_id) {
      if (this.settinganswer) { return false }
      this.settinganswer = true
      if (Number(this.questions[this.question_sequence].question_is_control) === 1) {
        this.controlanswers[question_id] = answer
        // Nullify all answers to questions that are controlled by this question
        for (let i = 0; i < this.questions.length; i++) {
          if (this.questions[i].controlquestion_id === question_id) {
            this.answers[i] = null
          }
        }
      } else {
        this.answers[id] = answer
      }
      await this.nextpage(300)
        .then(() => {
          this.settinganswer = false
        })
    },
    nextpage: async function (millisecs) {
      await sleep(millisecs).then(() => {
        const _this = this
        console.log('[GDQ] nextpage start: qs', _this.question_sequence, 'len', _this.questions.length, 'showtext', _this.showtext)
        // this.saveanswers(this.groupsurveymember_id,this.questions,this.answers)
        if (this.question_sequence === this.questions.length - 1) {
          const logdata = {
            op: 'Questionnaire done',
            url: window.location.href,
            ll: 1
          }
          this.$store.dispatch('accesslog', logdata)
          if (this.successurl !== '') {
            axios.get(this.successurl, { crossDOmain: true })
          }
          this.saveanswers(this.groupsurveymember_id, this.questions, this.answers)
            .then((resp) => {
              if (!resp.data.result || resp.data.result !== 'OK') {
                this.saveerror = 1
                this.senderror(JSON.stringify(resp.data))
                this.saving = false
              } else {
                this.saveerror = 0
                this.savefield(this.groupsurveymember_id, 'groupsurveymember_status_id', 4)
                this.$store.dispatch('addingsurveymember_set', { addingsurveymember: false })
                if (this.successurl !== '') {
                  axios.get(this.successurl, { crossDomain: true })
                }
                if (Number(this.survey.addon_survey) > 0) {
                  this.$router.push('/addonsurvey/' + this.survey.addon_survey + '/' + this.groupsurveymember_id)
                }
                this.saving = false
                this.alldone = true
              }
            })
          return false
        }
        let pp = parseInt(this.question_sequence)
        pp = pp + 2
        const logdata = {
          op: 'Questionnaire page: ' + pp,
          url: window.location.href,
          ll: 5
        }
        this.$store.dispatch('accesslog', logdata)
        if (_this.showtext) {
          _this.showtext = false
          if (_this.question_sequence > -1) {
            return
          }
        }
        const oldq = _this.question_sequence !== -1 ? this.questions[this.question_sequence] : { question_section: 'S' }
        const newq = _this.question_sequence < this.questions.length ? this.questions[this.question_sequence + 1] : null
        if (newq !== null) {
          if ((newq.question_section !== oldq.question_section) && newq.question_section !== 'E') {
            _this.showtext = true
          }
        }
        _this.question_sequence++
        // Ensure the new question has an initialized answer slot (empty string for text/textarea questions)
        if (_this.answers[_this.question_sequence] === undefined || _this.answers[_this.question_sequence] === null) {
          _this.$set
            ? _this.$set(_this.answers, _this.question_sequence, '')
            : (_this.answers[_this.question_sequence] = '')
        }
        const current = _this.questions[_this.question_sequence]
        console.log('[GDQ] nextpage after inc: qs', _this.question_sequence, 'showtext', _this.showtext, 'incontrolled', _this.incontrolled, 'question', {
          id: current?.question_id,
          section: current?.question_section,
          type: current?.question_type,
          only_digits: current?.only_digits,
          text_maxlength: current?.text_maxlength,
          is_control: current?.question_is_control,
          controlquestion_id: current?.controlquestion_id,
          show_on_value: current?.show_on_value
        })
        this.$nextTick(() => {
          const input = this.$refs.textAnswer
          if (input && input.focus) {
            input.focus()
            console.log('[GDQ] focus textAnswer success')
          } else {
            console.log('[GDQ] focus textAnswer missing')
          }
        })
        const ctlId = Number(_this.questions[_this.question_sequence].controlquestion_id)
        if (ctlId !== 0) {
          const ctlAnswer = _this.controlanswers[ctlId]
          // Only skip if we have an answer and it does not match the required value
          if (ctlAnswer !== undefined && ctlAnswer !== _this.questions[_this.question_sequence].show_on_value) {
            _this.incontrolled = true
            _this.nextpage(0)
            return
          }
          _this.incontrolled = false
        } else {
          _this.incontrolled = false
        }
      })
    },
    prevpage: function () {
      if (this.question_sequence === this.firstgdqsequence && !this.showtext) {
        this.showtext = true
        return true
      }
      if (this.showtext) { this.showtext = false }
      this.question_sequence--
      if (this.questions[this.question_sequence]) {
        const ctlId = Number(this.questions[this.question_sequence].controlquestion_id)
        if (ctlId !== 0) {
          const ctlAnswer = this.controlanswers[ctlId]
          if (
            ctlAnswer === undefined ||
            ctlAnswer !== this.questions[this.question_sequence].show_on_value
          ) {
            this.prevpage()
          }
        }
      }
    },
    consultant_get () {
      return new Promise((resolve) => {
        this.$store.dispatch('questionnaire_gdqconsultant_fetch', { user_id: this.consultant_id })
          .then((resp) => {
            this.consultant_email = resp.data.email
            this.consultant_name = resp.data.first_name + ' ' + resp.data.family_name
            resolve(resp)
          })
      })
    },
    // --------------------------------------------------------
    // Get all questions and answers for this here participant
    // --------------------------------------------------------
    gdqquestions_get: function () {
      const action = 'questionnaire_gdqallquestions_fetch'
      // Get ALL questions (GDQ and General)
      return new Promise((resolve) => {
        this.$store.dispatch(action, { survey_id: this.survey_id, language_id: this.survey.survey_language_id })
          .then((resp) => {
            const questions = resp.data
            this.questions = questions
            console.log('[GDQ] gdqquestions_get loaded', this.questions.length, 'questions')
            // Initialize answers/controlanswers to reactive empty strings for all questions
            this.answers = this.questions.map(() => '')
            this.controlanswers = []
            // Use array index of the first GDQ question so comparisons with question_sequence remain consistent
            const firstGdqIndex = this.questions.findIndex(q => q.question_section === 'Q')
            if (firstGdqIndex !== -1) {
              this.firstgdqsequence = firstGdqIndex
            } else if (this.questions.length) {
              this.firstgdqsequence = 0
            }
            resolve(resp)
          })
      })
    },
    saveanswers: function (groupsurveymember_id, questions, answers) {
      this.saving = true
      const saveanswers = []
      let question_sequence = 0
      questions.forEach(function (item) {
        if (!item.question_is_control || Number(item.question_is_control) === 0) {
          const newanswer = {
            question_id: item.question_id,
            question_section: item.question_section === 'Q' ? 'Q' : 'G',
            question_number: item.question_number,
            answer: answers[question_sequence]
          }
          saveanswers.push(newanswer)
        }
        question_sequence++
      })
      const data = {
        groupsurveymember_id,
        answers: saveanswers
      }
      return this.$store.dispatch('questionnaire_gdqallanswers_save', data)
        .then((resp) => {
          return resp
        })
    },
    savefield (id, fieldname, value) {
      if (!this.loading) {
        if (fieldname === 'survey_reminder') {
          if (!value) { value = 0 }
        }
        if (fieldname.indexOf('_date') !== -1) {
          value = this.format_date(value)
        }
        if (fieldname.indexOf('_time') !== -1) {
          if (value !== null && value !== '') { value = this.format_time(value) } else { value = '00:00' }
        }
        const data = {
          id,
          [fieldname]: value
        }
        this.formchanged = false
        this.$store.dispatch('questionnaire_surveymember_setstatus', { surveymember: data })
          .then((resp) => {
            return (resp)
          })
      }
    },
    // Send e-mail on save error
    senderror (text) {
      const send_mail_subject = 'GDQ: Error saving'
      const send_mail_text = text
      const payload = {
        mail_to: 'qbjorn@gmail.com',
        mail_subject: send_mail_subject,
        mail_text: send_mail_text
      }
      return this.$store.dispatch('mail_send', payload)
    },
    //= ================
    // HELPER FUNCTIONS
    //= ================
    format_date (date) {
      const d = new Date(date)
      let month = '' + (d.getMonth() + 1)
      let day = '' + d.getDate()
      const year = d.getFullYear()
      if (isNaN(year)) { return '' }
      if (Number.isNaN(month)) { return '' }
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('-')
    },
    format_time (date) {
      if (date.length === 5) {
        return date
      }
      const d = new Date(date)
      const h = d.getHours()
      const m = d.getMinutes()
      const hour = (h > 9 ? '' : '0') + h
      const minute = (m > 9 ? '' : '0') + m
      const thistime = hour + ':' + minute
      return thistime
    }
  },
  watch: {
    consent_personal (newValue) {
      this.persistConsent('groupsurveymember_consent_personal', newValue)
    },
    consent_research (newValue) {
      this.persistConsent('groupsurveymember_consent_research', newValue)
    }
  }
}
</script>
<style>
/*
.btn {
  border-radius: 0px !important;
}
*/
.btn.btn-questionnaire {
  border-radius: 0px !important;
  font-size: 24px !important;
  font-weight: 400 !important;
  line-height: 150% !important;
}
.btn-group-vertical .btn-questionnaire,
.btn-group-vertical .btn-questionnaire:first-child,
.btn-group-vertical .btn-questionnaire:last-child {
  border-radius: 0 !important;
}
.btn-group-vertical .btn-questionnaire:not(:last-child),
.btn-group-vertical .btn-questionnaire:not(:first-child) {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.btn-outline-primary:hover {
  background-color: white !important;
  border-color: #007d8f !important;
  color: #007d8f !important;
  border-radius: 0px !important;
}
.btn-questionnaire-horizontal {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
[type='radio'] {
  display: none;
}
.gdqquestion {
  transition: opacity 2.5s;
}
.gdqquestion-enter-active, .gdqquestion-leave-active {
  transition: opacity 2.5s;
}
.gdqquestion-enter, .gdqquestion-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.text-container {
  max-width: 794px;
  margin: 0 auto;
}

.gdq-progress-bar {
  background-color: #e5e8eb;
  border-radius: 50px;
  height: 1rem;
  width: 100%;
}

.gdq-progress-bar .progress-bar {
  background-color: #b3dcd0;
  border-radius: 50px;
}

.white.fa-icon {
  color: white !important;
  fill: white !important;
  margin-right: 8px;
}

.saving-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.85);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.saving-overlay-content {
  text-align: center;
}
</style>
